import { ChildUserPermissions } from "./child-user.permissions.model";

export class ChildUser {
  id: number;
  name: string;
  email: string;
  password: string;
  permissions: ChildUserPermissions;
}